export default "__VITE_ASSET__ani58Tk4__"